/* Unike Love landing kit v2: motion + behavior. Vanilla JS, no dependencies.
   html.js is set inline in <head>; window.lpReady tells the head failsafe that this file loaded. */
(function () {
  window.lpReady = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  // Wrap every word in <span class="w"><span>word</span></span> so it can rise from a mask.
  function splitWords(el) {
    if (el.classList.contains('is-split')) return;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 1) { walk(child); return; }
        if (child.nodeType !== 3 || !child.textContent.trim()) return;
        var frag = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
          var outer = document.createElement('span');
          var inner = document.createElement('span');
          outer.className = 'w';
          inner.textContent = part;
          inner.style.setProperty('--i', i++);
          outer.appendChild(inner);
          frag.appendChild(outer);
        });
        node.replaceChild(frag, child);
      });
    })(el);
    el.classList.add('is-split');
  }

  // "500+" -> counts 0..500 keeping prefix/suffix.
  function countUp(el) {
    var m = el.textContent.trim().match(/^(\D*)(\d+)(.*)$/);
    if (!m) return;
    var target = parseInt(m[2], 10), start = null, dur = 1600;
    function frame(t) {
      if (!start) start = t;
      var k = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - k, 4);
      el.textContent = m[1] + Math.round(target * eased) + m[3];
      if (k < 1) requestAnimationFrame(frame);
    }
    el.textContent = m[1] + '0' + m[3];
    requestAnimationFrame(frame);
  }

  function tilt(el, max, target) {
    var layer = target || el;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      layer.style.transition = 'transform .12s linear';
      layer.style.transitionDelay = '0ms';
      layer.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * max) + 'deg) rotateY(' + ((x - 0.5) * max) + 'deg)';
      layer.style.setProperty('--gx', (x * 100) + '%');
      layer.style.setProperty('--gy', (y * 100) + '%');
      layer.classList.add('is-hover');
    });
    el.addEventListener('pointerleave', function () {
      layer.style.transition = 'transform .7s cubic-bezier(.16,1,.3,1)';
      layer.style.transform = '';
      layer.classList.remove('is-hover');
    });
  }

  // Gold dust drifting up through the hero. Paused whenever the hero is off screen.
  function sparks(canvas, hero) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), w, h, dots = [], running = false;
    function size() {
      w = hero.clientWidth; h = hero.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = w < 720 ? 16 : 40;
      dots = [];
      for (var i = 0; i < n; i++) dots.push(spawn(true));
    }
    function spawn(anywhere) {
      return { x: Math.random() * w, y: anywhere ? Math.random() * h : h + 10, r: 0.6 + Math.random() * 1.6,
        vy: 0.12 + Math.random() * 0.38, vx: (Math.random() - 0.5) * 0.12, ph: Math.random() * 6.28 };
    }
    function draw() {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      dots.forEach(function (d, i) {
        d.y -= d.vy; d.x += d.vx; d.ph += 0.03;
        if (d.y < -10) dots[i] = spawn(false);
        var a = 0.25 + 0.45 * (0.5 + 0.5 * Math.sin(d.ph));
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r, 0, 6.283);
        ctx.fillStyle = 'rgba(212,165,116,' + a.toFixed(3) + ')';
        ctx.shadowColor = 'rgba(236,200,150,.8)';
        ctx.shadowBlur = 6;
        ctx.fill();
      });
      requestAnimationFrame(draw);
    }
    size();
    window.addEventListener('resize', size);
    new IntersectionObserver(function (entries) {
      var on = entries[0].isIntersecting;
      if (on && !running) { running = true; requestAnimationFrame(draw); }
      if (!on) running = false;
    }).observe(hero);
  }

  function heroVideo(hero) {
    var url = hero.getAttribute('data-video');
    var saveData = navigator.connection && navigator.connection.saveData;
    if (!url || window.innerWidth < 1024 || saveData) return;
    window.addEventListener('load', function () {
      var bg = hero.querySelector('.lp-hero__bg');
      var v = document.createElement('video');
      v.className = 'lp-hero__video';
      v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      v.setAttribute('aria-hidden', 'true');
      v.setAttribute('preload', 'auto');
      v.src = url;
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
      bg.appendChild(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  // Hero crystal carousel: each new crystal is "engraved" in by the laser line.
  function heroSlides(hero) {
    var slides = $all('.lp-slide', hero);
    if (slides.length < 2) return;
    var dots = $all('.lp-dots button', hero);
    var tiltLayer = hero.querySelector('.lp-tilt');
    var laser = hero.querySelector('.lp-laser');
    var every = 5500, current = 0, timer;
    hero.style.setProperty('--slide-ms', every + 'ms');
    function show(n) {
      n = (n + slides.length) % slides.length;
      if (n === current) return;
      var prev = slides[current], next = slides[n];
      current = n;
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 900);
      next.style.setProperty('--delay', '0s');
      next.classList.add('is-active');
      tiltLayer.style.setProperty('--mask', 'url("' + (next.currentSrc || next.src) + '")');
      if (laser) {
        laser.style.animation = 'none';
        void laser.offsetWidth;
        laser.style.animation = 'lp-scan 1.8s cubic-bezier(.65,0,.35,1) forwards';
      }
      dots.forEach(function (d, k) {
        d.classList.remove('is-active');
        if (k === n) { void d.offsetWidth; d.classList.add('is-active'); }
      });
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show(current + 1); }, every); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    // Wait for the first reveal to finish before cycling.
    setTimeout(function () {
      if (dots[0]) { dots[0].classList.remove('is-active'); void dots[0].offsetWidth; dots[0].classList.add('is-active'); }
      start();
    }, 2400);
  }

  ready(function () {
    var hero = document.querySelector('.lp-hero');
    var nav = document.querySelector('.lp-nav');
    var sticky = document.querySelector('.lp-sticky');
    var progress = document.createElement('div');
    progress.className = 'lp-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);

    // Headlines rise word by word.
    $all('.lp-hero .lp-h1, .lp-h2').forEach(splitWords);
    if (hero) {
      var heroIn = function () { hero.classList.add('is-in'); };
      requestAnimationFrame(function () { requestAnimationFrame(heroIn); });
      setTimeout(heroIn, 120); // backup when rAF is paused (tab opened in the background)
    }

    // Stagger index for grouped items.
    $all('.lp-pains, .lp-grid, .lp-steps, .lp-quotes, .lp-stack__list ul, .lp-stats .lp-wrap').forEach(function (group) {
      Array.prototype.slice.call(group.children).forEach(function (child, i) { child.style.setProperty('--i', i); });
    });

    var revealSel = '.lp-head, .lp-store, .lp-score, .lp-guar, .lp-faq, .lp-stack, .lp-proof__score, .lp-cta-row, .lp-closer .lp-lede, .lp-closer .lp-micro, .lp-h2, ' +
      '.lp-pains, .lp-grid, .lp-steps, .lp-quotes, .lp-stack__list ul, .lp-stats .lp-wrap';
    var targets = $all(revealSel);
    if (reduce || !hasIO) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('is-in');
          io.unobserve(el);
          if (el.matches('.lp-stats .lp-wrap')) $all('.lp-num', el).forEach(countUp);
          // Once revealed, drop stagger delays so hover effects respond instantly.
          setTimeout(function () {
            Array.prototype.slice.call(el.children).forEach(function (c) { c.style.transitionDelay = '0ms'; });
          }, 1800);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (el) { io.observe(el); });
    }

    if (!reduce) {
      if (hero) {
        var canvas = hero.querySelector('.lp-sparks');
        if (canvas && hasIO) sparks(canvas, hero);
        heroVideo(hero);
        heroSlides(hero);
      }
      if (finePointer) {
        $all('[data-tilt]').forEach(function (el) { tilt(el, 12, el.querySelector('.lp-tilt')); });
        $all('.lp-grid .lp-tile').forEach(function (el) { tilt(el, 7); });
      }
    }

    // Scroll-driven: header state, progress bar, cinematic showcase.
    var shows = $all('.lp-show');
    var ticking = false;
    function onScroll() {
      ticking = false;
      var y = window.scrollY, vh = window.innerHeight;
      var max = document.documentElement.scrollHeight - vh;
      if (nav) nav.classList.toggle('is-scrolled', y > 24);
      progress.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      if (!reduce) {
        shows.forEach(function (s) {
          var r = s.getBoundingClientRect();
          var p = Math.min(Math.max(-r.top / (r.height - vh), 0), 1);
          s.style.setProperty('--p', p.toFixed(4));
        });
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    // Sticky CTA appears once the hero has scrolled out of view.
    if (hero && sticky && hasIO) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      }).observe(hero);
    }

    // Countdowns: any element with data-deadline (ISO date). Hidden when missing or past.
    var timers = $all('[data-deadline]');
    if (!timers.length) return;
    function parse(value) {
      if (!value) return NaN;
      var v = value.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) v += 'T23:59:59-05:00'; // end of that day, Miami time
      return Date.parse(v);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      timers.forEach(function (el) {
        var end = parse(el.getAttribute('data-deadline'));
        var wrap = el.closest('[data-cd-wrap]') || el;
        var fallback = (wrap.parentNode || document).querySelector('[data-cd-fallback]');
        var left = end - now;
        if (isNaN(end) || left <= 0) {
          wrap.hidden = true;
          if (fallback) fallback.hidden = false;
          return;
        }
        wrap.hidden = false;
        if (fallback) fallback.hidden = true;
        var s = Math.floor(left / 1000);
        var parts = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(parts).forEach(function (k) {
          var slot = el.querySelector('[data-' + k + ']');
          if (!slot) return;
          var val = k === 'd' ? String(parts[k]) : pad(parts[k]);
          if (slot.textContent !== val) {
            slot.textContent = val;
            if (!reduce) { slot.classList.remove('tick'); void slot.offsetWidth; slot.classList.add('tick'); }
          }
        });
      });
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Conversion tracking: phone taps, directions, CTA clicks ---------- */
  // gtag + window.lpTrack come from the lp-tracking snippet. One delegated listener covers every link.
  var PHONE_RE = /\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/;

  function linkLocation(a) {
    var zones = [['.lp-bar', 'bar'], ['.lp-nav', 'header'], ['.lp-hero', 'hero'], ['.lp-sticky', 'sticky'], ['.lp-foot', 'footer'], ['.lp-store', 'store'], ['.lp-closer', 'closer'], ['.lp-stack', 'offer'], ['.lp-grid', 'tiles']];
    for (var i = 0; i < zones.length; i++) if (a.closest(zones[i][0])) return zones[i][1];
    return 'body';
  }

  // On ad visits Google swaps the displayed number for a forwarding number; make the tap dial what the visitor sees.
  function syncTel(a) {
    var shown = (a.textContent.match(PHONE_RE) || [])[0];
    if (!shown) {
      var nav = document.querySelector('.lp-nav__tel');
      shown = nav && (nav.textContent.match(PHONE_RE) || [])[0];
    }
    var digits = shown ? shown.replace(/\D/g, '') : '';
    if (digits.length === 10) a.setAttribute('href', 'tel:+1' + digits);
  }

  document.addEventListener('click', function (e) {
    var t = window.lpTrack;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !t || typeof window.gtag !== 'function') return;
    var href = a.getAttribute('href');
    var where = linkLocation(a);
    try {
      if (/^tel:/i.test(href)) {
        syncTel(a);
        gtag('event', 'conversion', { send_to: t.callClick, value: 20, currency: 'USD' });
        gtag('event', 'click_to_call', { send_to: t.ga4, lp: t.page, link_location: where });
      } else if (/google\.[a-z.]+\/maps\/dir/i.test(href)) {
        gtag('event', 'conversion', { send_to: t.directions, value: 10, currency: 'USD' });
        gtag('event', 'get_directions', { send_to: t.ga4, lp: t.page, link_location: where });
      } else if (a.classList.contains('lp-btn') || a.closest('.lp-tile')) {
        gtag('event', 'lp_cta_click', { send_to: t.ga4, lp: t.page, link_location: where, link_text: a.textContent.replace(/\s+/g, ' ').trim().slice(0, 60), link_url: href });
      }
    } catch (err) { /* tracking must never block navigation */ }
  }, true);
})();
